import React from 'react'
import mission from '../../assets/images/mission.svg'
import vision from '../../assets/images/vision.svg'
import values from '../../assets/images/values.svg'
import { Col, Row } from 'reactstrap'

const AboutContent = () => {
    return (
        <Row className='about-content'>
            <Col xs={12} sm={12} md={4} lg={4} xl={4} xxl={4} className='mb-5 d-flex justify-content-center'>
                <div className='item'>
                    <div><img src={mission} alt='' /></div>
                    <div className='mt-4'>
                        <div><h4>MISSION</h4></div>
                        <div className='mt-3'><span>At Liberyus, we aim to design innovative and user-centric digital solutions that empower businesses to thrive in a fast-changing digital world. By delivering high-quality applications, exceptional designs, and impactful branding strategies, we help businesses achieve measurable success.</span></div>
                    </div>
                </div>
            </Col>
            <Col xs={12} sm={12} md={4} lg={4} xl={4} xxl={4} className='mb-5 d-flex justify-content-center'>
                <div className='item'>
                    <div><img src={vision} alt='' /></div>
                    <div className='mt-4'>
                        <div><h4>VISION</h4></div>
                        <div className='mt-3'><span>Our vision is to become a global leader in transformative digital experiences. By combining creativity, technology, and strategy, we strive to shape the future of design and innovation, enabling businesses worldwide to reach their full potential.</span></div>
                    </div>
                </div>
            </Col>
            <Col xs={12} sm={12} md={4} lg={4} xl={4} xxl={4} className='mb-5 d-flex justify-content-center'>
                <div className='item'>
                    <div><img src={values} alt='' /></div>
                    <div className='mt-4'>
                        <div><h4>VALUES</h4></div>
                        <div className='mt-3'><span>At Liberyus, we value innovation, collaboration, and excellence, delivering high-quality solutions tailored to our clients’ needs. Guided by integrity, we prioritize transparency and trust while focusing on creating seamless, user-centric experiences.</span></div>
                    </div>
                </div>
            </Col>
        </Row>
    )
}

export default AboutContent
